import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Chips } from "primereact/chips";

const FormField = forwardRef(({ config, value, onChange, cofigField }, ref) => {
  const fileInputRef = useRef(null);
  const { key, label, type, options, placeholder, required } = config;
  const [error, setError] = useState("");
  useImperativeHandle(ref, () => ({
    validate: () => {
      return validateField(value);
    },
  }));
  const validateField = (val) => {
    if (required) {
      if (type === "chips" && (!val || val.length === 0)) {
        setError(`${label} is required`);
        return false;
      } else if (type === "file" && !val) {
        setError(`${label} is required`);
        return false;
      } else if (type === "inputtranslation" && (!val?.english || val.english.trim() === "")) {
        setError(`${label} is required`);
        return false;
      } else if (!val || val === "") {
        setError(`${label} is required`);
        return false;
      }
      if (key === "path" && val && typeof val === "string") {
        const trimmedVal = val.trim();
        if (!/^https?:\/\//i.test(trimmedVal)) {
          setError("Please enter a valid URL starting with http:// or https://");
          return false;
        }
      }
    }
    setError("");
    return true;
  };

  const handleInputChange = (fieldKey, val, e) => {
    const field = cofigField.find((f) => f.key === fieldKey);
    validateField(val);
    if (type === "file") {
      const file = e.target.files?.[0];
      onChange(file);
    } else if (type === "chips" || type === "dropdown") {
      onChange(val);
    } else {
      onChange(val, fieldKey);
    }
    if (field?.onChange) field.onChange(e);
  };
  const translateToMarathi = async (text) => {
    try {
      const response = await fetch(
        `https://api.mymemory.translated.net/get?q=${encodeURIComponent(
          text
        )}&langpair=en|mr`
      );
      const data = await response.json();
      return data.responseData.translatedText;
    } catch (error) {
      console.error("Translation error:", error);
      return "";
    }
  };
  const handleTranslation = async (englishText) => {
    if (!englishText.trim()) {
      setError(`${label} is required`);
      onChange({ english: "", marathi: "" }, key);
      return;
    }
    const marathiText = await translateToMarathi(englishText);
    setError("");
    onChange({ english: englishText, marathi: marathiText }, key);
  };
  const triggerFileSelect = () => {
    fileInputRef.current.click();
  };
  return (
    <div className="form-field flex flex-col gap-1">
      <label htmlFor={key} className="font-medium">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {type === "text" && (
        <InputText
          id={key}
          value={value || ""}
          onChange={(e) =>
            handleInputChange(key, e.target.value, e)
          }
          placeholder={placeholder}
          className="form-input"
        />
      )}
      {type === "dropdown" && (
        <Dropdown
          id={key}
          value={value || ""}
          options={options}
          onChange={(e) =>
            handleInputChange(key, e.target.value, e)
          }
          placeholder={placeholder}
          className="form-dropdown"
        />
      )}
      {type === "file" && (
        <div className="file-input-wrapper">
          {value && typeof value === "string" && value.startsWith("http") ? (
            <div className="file-preview">
              <a href={value} target="_blank" rel="noopener noreferrer">
                {value.split("/").pop()} (View)
              </a>
              <button
                type="button"
                className="remove-file-btn"
                onClick={() => onChange(null)}
              >
                Remove
              </button>
            </div>
          ) : (
            <>
              <input
                type="file"
                id={key}
                ref={fileInputRef}
                onChange={(e) => handleInputChange(key, e.target.files[0], e)}
                className="form-input"
                placeholder={placeholder || "No file chosen"}
              />
            </>
          )}
        </div>
      )}
      {type === "chips" && (
        <Chips
          id={key}
          value={value || []}
          onChange={(e) =>
            handleInputChange(key, e.target.value, e)
          }
          placeholder={placeholder}
          className="w-full"
        />
      )}
      {type === "inputtranslation" && (
        <div>
          <InputText
            id={`${key}_en`}
            value={value?.english || ""}
            onChange={(e) => handleTranslation(e.target.value)}
            placeholder={`Enter ${label}`}
            className="form-input"
          />
          <InputText
            id={`${key}_mr`}
            value={value?.marathi || ""}
            onChange={(e) =>
              onChange({ ...value, marathi: e.target.value }, key)
            }
            placeholder={`Translated ${label} in Marathi`}
            className="form-input"
          />
        </div>
      )}
      {error && <small className="text-red-500">{error}</small>}
    </div>
  );
});

export default FormField;